module.exports = __webpack_public_path__ + "static/suitcases-5ed8d073b90b6e4e80cd9ef9d11de138.jpg";